import React from "react";
import "./ResultBottomNavigation.css";

const ResultBottomNavigation = ({
  onReviewAnswers,
  onShareScore,
  onLeaderboard,
  onHome,
}) => {
  return (
    <div className="result-bottom-nav">
      {/* Review Answers */}
      <button
        type="button"
        className="result-nav-item"
        onClick={onReviewAnswers}
      >
        <span className="result-nav-icon review-icon">
          <i className="bi bi-journal-text"></i>
        </span>

        <span className="result-nav-label">
          Review Answers
        </span>
      </button>

      {/* Share Score */}
      <button type="button" className="result-nav-item" onClick={onShareScore}>
        <span className="result-nav-icon share-icon">
          <i className="bi bi-share-fill"></i>
        </span>

        <span className="result-nav-label">
          Share Your Score
        </span>
      </button>

      {/* Leaderboard */}
      <button type="button" className="result-nav-item" onClick={onLeaderboard}>
        <span className="result-nav-icon leaderboard-icon">
          <i className="bi bi-trophy-fill"></i>
        </span>

        <span className="result-nav-label">Leaderboard</span>
      </button>

      {/* Home */}
      <button type="button" className="result-nav-item" onClick={onHome}>
        <span className="result-nav-icon home-icon">
          <i className="bi bi-house-door-fill"></i>
        </span>

        <span className="result-nav-label">Home</span>
      </button>
    </div>
  );
};

export default ResultBottomNavigation;
